import React from 'react';

import { useSettings } from 'app/main/components';
import type { DetailsPageRightSidebarProps } from 'app/main/components/page-layouts';

import OrdersDetailsSectionStatsGeneral from './sections/OrdersDetailsSectionStatsGeneral';
import OrdersDetailsSectionStatsWorkReports from './sections/OrdersDetailsSectionStatsWorkReports';

import OrdersDetailsSectionCheckRows from './sections/OrdersDetailsSectionCheckRows';
import OrdersDetailsSectionMinValue from './sections/OrdersDetailsSectionMinValue';
import OrdersDetailsSectionShippingCharges from './sections/OrdersDetailsSectionShippingCharges';
import OrdersDetailsSectionMerchPoints from './sections/OrdersDetailsSectionMerchPoints';

import getOrdersPromosDetailsSections from '../components/OrdersPromosDetailsSections';

export default function OrdersDetailsRightSidebar(props: DetailsPageRightSidebarProps) {
	const { sysSettings } = useSettings();

	const minOrderValue = sysSettings.b2b_min_order_value || 0;
	const isShippingModuleEnabled = sysSettings.orders_shipping_enabled === 'true';

	const showError = [1, 4, 5].includes(props.model.ords_orst_id) && !!props.model.ords_error;

	// const stats = props.model.ords_stats;
	// const workReportsStats = stats?.ords_workreports_stats;

	const sections: React.ReactNode[] = [];

	if (!props.isAdd) {
		if (showError) {
			sections.push(
				<OrdersDetailsSectionCheckRows orderUid={props.model.ords_uid} updateRefresh={props.updateRefresh} />
			);
		}

		if (props.model.ords_tot_value_tax_excl < minOrderValue) {
			sections.push(<OrdersDetailsSectionMinValue orderTotValueTaxExcl={props.model.ords_tot_value_tax_excl} />);
		}

		if (isShippingModuleEnabled) {
			sections.push(
				<OrdersDetailsSectionShippingCharges
					orderUid={props.model.ords_uid}
					country={props.model.ords_shad_ctry_title}
					orderTotValueTaxExcl={props.model.ords_tot_value_tax_excl}
				/>
			);
		}

		if (props.model.ords_merchandise_active) {
			sections.push(
				<OrdersDetailsSectionMerchPoints
					orderUid={props.model.ords_uid}
					orderStatusId={props.model.ords_orst_id}
					pricingGroupId={props.model.ords_pric_id}
					orderMerchandise={props.model.ords_merchandise}
					orderTotMerchPointsSpent={props.model.ords_tot_merchpoints_spent}
					orderTotMerchPointsEarned={props.model.ords_tot_merchpoints_earned}
					updateRefresh={props.updateRefresh}
				/>
			);
		}

		const promosSections = getOrdersPromosDetailsSections({
			orderUid: props.model.ords_uid,
			orderStatusId: props.model.ords_orst_id,
			orderTotValueTaxExcl: props.model.ords_tot_value_tax_excl
		});
		if (promosSections?.length > 0) sections.push(...promosSections);

		// if (stats) {
		// 	sections.push(<OrdersDetailsSectionStatsGeneral stats={stats} />);
		// }
		// if (workReportsStats) {
		// 	sections.push(<OrdersDetailsSectionStatsWorkReports stats={workReportsStats} />);
		// }
	}

	return sections;
}
